<div
  (click)="onLayoutClick()"
  [attr.data-theme]="colorScheme"
  [class]="colorScheme === 'light' ? menuTheme : ''"
  [ngClass]="{
    'layout-overlay': menuMode === 'overlay',
    'layout-static': menuMode === 'static',
    'layout-slim': menuMode === 'slim',
    'layout-sidebar-dim': colorScheme === 'dim',
    'layout-sidebar-dark': colorScheme === 'dark',
    'layout-overlay-active': overlayMenuActive,
    'layout-mobile-active': staticMenuMobileActive,
    'layout-static-inactive':
      staticMenuDesktopInactive && menuMode === 'static',
    'p-input-filled': inputStyle === 'filled',
    'p-ripple-disabled': !ripple
  }"
  class="layout-wrapper"
>
  <div class="layout-content-wrapper">
    <boma-portal-top-bar
      (handleMenuButtonClick)="onMenuButtonClick($event)"
      (handleRightMenuClick)="onRightMenuClick($event)"
      (handleSearchClick)="onSearchClick($event)"
      (handleTopbarUserMenuButtonClick)="onTopbarUserMenuButtonClick($event)"
      (handleTopbarNotificationMenuButtonClick)="
        onTopbarNotificationMenuButtonClick($event)
      "
      [adminportal]="true"
      [topBarNotificationMenuActive]="false"
      [topbarUserMenuActive]="topbarUserMenuActive"
      [user]="user$ | async"
    ></boma-portal-top-bar>

    <div class="layout-content">
      <router-outlet></router-outlet>
    </div>

    <boma-portal-footer></boma-portal-footer>
  </div>

  <boma-portal-menu
    (handleMenuClick)="onMenuClick()"
    (handleMenuHoverActive)="onSetMenuHoverActive()"
    (handleMenuHoverActiveFalse)="onSetMenuHoverActiveFalse()"
    (handleStaticMenuMobileActiveFalse)="onSetStaticMenuMobileActiveFalse()"
    (handleUnblockBodyScroll)="unblockBodyScroll()"
    [isDesktop]="isDesktop()"
    [isMenuHoverActive]="isMenuHoverActive()"
    [isMobile]="isMobile()"
    [isSlim]="isSlim()"
    [menuItems]="menuItems"
    [adminDash]="true"
  ></boma-portal-menu>

  <div class="layout-mask modal-in"></div>
  <boma-toast></boma-toast>
</div>
